import { format, isValid, parseISO } from "date-fns";
import { enAU } from "date-fns/locale";

export const DISPLAY_DATE_FORMAT = "dd MMM yyyy";
export const DISPLAY_DATETIME_FORMAT = "dd MMM yyyy, h:mm a";
export const DISPLAY_DATE_FORMAT_LABEL = "DD MMM YYYY";
export const DISPLAY_DATETIME_FORMAT_LABEL = "DD MMM YYYY, h:mm AM/PM";
export const DISPLAY_DATE_TOOLTIP = `Date format: ${DISPLAY_DATE_FORMAT_LABEL} (e.g. 03 Apr 2026)`;
export const DISPLAY_DATETIME_TOOLTIP = `Date format: ${DISPLAY_DATETIME_FORMAT_LABEL}`;

const SLASH_DATE_REGEX = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
const EPOCH_MILLIS_REGEX = /^\d{13,}$/;
const ISO_PREFIX_REGEX = /^\d{4}-\d{2}-\d{2}/;

/** Parse API / form values (ISO, slash AU dates, timestamps) into a Date. */
export function parseToDate(value) {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === "number") {
    const fromMillis = new Date(value);
    return isValid(fromMillis) ? fromMillis : null;
  }

  const str = String(value).trim();
  const slashMatch = str.match(SLASH_DATE_REGEX);
  if (slashMatch) {
    const [, day, month, year] = slashMatch;
    const parsed = parseISO(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
    return isValid(parsed) ? parsed : null;
  }

  if (EPOCH_MILLIS_REGEX.test(str)) {
    const fromMillis = new Date(Number(str));
    return isValid(fromMillis) ? fromMillis : null;
  }

  if (ISO_PREFIX_REGEX.test(str)) {
    const parsed = parseISO(str.replace(" ", "T"));
    if (isValid(parsed)) return parsed;
  }

  const parsed = new Date(str);
  return isValid(parsed) ? parsed : null;
}

/** Convert d/M/yyyy or dd/MM/yyyy (day first) to yyyy-MM-dd for HTML date inputs. */
export function convertDateFormat(dateStr) {
  if (!dateStr) return dateStr;
  const str = String(dateStr).trim();
  const match = str.match(SLASH_DATE_REGEX);
  if (!match) return dateStr;
  const [, day, month, year] = match;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function formatDisplayDate(value, fallback = "—") {
  const d = parseToDate(value);
  return d ? format(d, DISPLAY_DATE_FORMAT, { locale: enAU }) : fallback;
}

export function formatDisplayDateTime(value, fallback = "—") {
  const d = parseToDate(value);
  return d ? format(d, DISPLAY_DATETIME_FORMAT, { locale: enAU }) : fallback;
}
